import { useEffect, useState } from "react"
import { useNavigate  } from "react-router-dom"
import { useQuizStore } from "./useQuizStore"
import { useQuizMachine } from "./useQuizMachine"
import { useRecoilState } from "recoil"
import { quizLoaded } from "../states/quizState"

export const useQuizForm = (quizName: string,  route: string, stepId?: string, id?: string, userId?: string): useQuizFormType => {
    const { getResponsesList,
        setResponseList,
        getStepsList,
        setStepList,
        addResponse,
        addStep,
        getlastStep,
        getfirstStep,
        removeSteps,
        removeResponses, 
        addFilledResponse,
        getFilledResponses,
        setFilledResponses,
        getPrevState } = useQuizStore()
    const navigate = useNavigate()
    const { config, transition, initial, machine} = useQuizMachine(quizName, id, userId);
    const [initState, setInitState] = useState(getfirstStep());
    const [currentState, setCurrentState] = useState(stepId?.toString() || getlastStep() || initState);
    const [events, setEvents] = useState({});
    const [meta, setMeta] = useState<any>();
    const [currentPosition, setCurrentPosition] = useState<number>()
    const [defaultResponse, setDefaultResponse] = useState<string>()
    const [stepLeft, setStepLeft] = useState<number>()
    const [isfinalState, setFinalState] = useState(false)
    const [quizLoad, setQuizLoad] = useRecoilState(quizLoaded)

    useEffect(() => {
        if(initial && !initState && !id) {
            setInitState(initial)
            navigate(`${route}/${initial}`)
        }
    }, [initial])

    useEffect(() => {
        if (stepId) {
            setCurrentState(stepId.toString())
            setDefaultResponse(getFilledResponses().find(res => res.split('-')?.[0] == `${process.env.REACT_APP_TRANSITION_PREFIX}${stepId}`))
        } else {
            goToLastStep()
        }
    }, [stepId])

    useEffect(() => {
        if (currentState && currentState != getlastStep()) {
            computeState(currentState)
        }
        if (currentState && config && config.states) {
            const stateNode = config.states[currentState];
            setEvents(stateNode?.on || {})
            setMeta(stateNode?.meta)
            setCurrentPosition(Object.keys(config?.states)
                ?.map((item, index) => { return {value: item, index}})
                ?.find(item => item?.value == currentState)?.index)
            setFinalState(stateNode?.meta?.type == 'outputBox' || (!Object.keys(stateNode?.on)?.length) ? true: false)
        }
    }, [currentState, config])

    useEffect(() => {
        if(currentState && transition && machine) {
            !quizLoad.depth && setQuizLoad({...quizLoad, depth: getStepLeft(machine.initialState)})
            if(getPrevState()) {
                const s =  transition(getPrevState()?.stateName, getPrevState()?.eventName)
                setStepLeft(isfinalState ? getStepLeft(s) - 1 : getStepLeft(s))
            }   else {
                setStepLeft(getStepLeft(machine.initialState))
            }
        }
    }, [currentState, machine, transition, isfinalState])

    const computeState = (state: string) => {
        const index = getStepsList()?.indexOf(state)
        if (index != undefined && index != -1) {
            const resList = getResponsesList()?.slice(0, index)
            resList.length > 0 ? setResponseList(resList.join(';')) : removeResponses()
            const stepList = getStepsList()?.slice(0, (index + 1))
            console.log(stepList)
            stepList.length > 0 ? setStepList(stepList.join(';')) : removeSteps()
        } else if (getStepsList()?.length == getResponsesList()?.length) {
            addStep(state)
        } else {
            goToLastStep()
            setResponseList(getFilledResponses().join(';'))
            addStep(state)
        }
    }

    const handleRespond = (key: string) => {
        const newState = transition?.(currentState, key).value.toString()
        setCurrentState(newState)
        
        if( getFilledResponses().length <= getResponsesList().length) {
            addFilledResponse(key)
        } else if(getFilledResponses()[getResponsesList().length] != key) {
            setFilledResponses(getResponsesList().join(';'))
            addFilledResponse(key)
        }
        addResponse(key)
        navigate(`${route}/${newState}`)
    }

    const goToLastStep = () => {
        const stepName = getlastStep()
        stepName ? navigate(`${route}/${stepName}`) : handleClear()
    }

    const handleClear = () => {
        initState && navigate(`${route}/${initState}`)
    }

    const handleBack = () => {
        const backStep = getStepsList()?.length  > 1 && getStepsList()?.[getStepsList()?.length - 2]
        backStep 
        ? navigate(`${route}/${backStep}`)
        : navigate(`/quiz`)
    }

    const getStepLeft = (state: any) => {
        const list = countDepth(state)
        return getMaxDepth(list)
    }

    const countDepth = (state: any): any []=> {
        
        if(state.nextEvents?.length <= 0) {
            return [1]
        }
        return state.nextEvents?.map((e: string) => {
            const nextState = transition(state, e)
            const r = countDepth(nextState)
            return r.map((item: number) =>  item)
        });
    }

    const getMaxDepth = (count: any []) => { 
        let el = count
        let num = 0
        let isFlatted = false
        while(!isFlatted) {
            num = num + 1 
            el = el.flat()
            isFlatted = checkFlatArray(el)
        }
        return num
    }


    const checkFlatArray = (el: any []) => {
        let isFlatted = true
        el.forEach((item: any) => {
            if(item.constructor === Array) {
                isFlatted = false
            }
        });
        return isFlatted
    }

    return {
        handleRespond,
        handleClear,
        handleBack,
        meta,
        events,
        currentPosition,
        defaultResponse,
        currentState,
        stepLeft,
        isfinalState
    }
}

type useQuizFormType = {
    /** prop contain metaData */
    meta: { [key: string]: any }
    /** prop contain events or reponses */
    events: { [key: string]: any }
    /** prop for number of state that machine contain */
    currentPosition?: number
    defaultResponse?: string
    currentState?: string
    stepLeft?: number
    isfinalState?: boolean
    /** handler for respond */
    handleRespond: (val: string) => void
    /** handler for clear */
    handleClear: () => void
    handleBack: () => void
}